define('post-editor/image-plugin',['post-editor/sidebar-api', 'tinymce/EditorManager'], function(api, EditorManager) {
	api.defineGroups('img.image', [{
		title: 'Bild',
		type: 'panel',
		layout: 'flow',
		items: [{
			type: 'button',
			text: 'Lizenz bearbeiten',
			onClick: function() {
				EditorManager.activeEditor.execCommand('wa5_image');
			}
		},{
			type: 'button',
			text: 'Bild zuschneiden',
			onClick: function() {
				EditorManager.activeEditor.execCommand('wa5_image_cropping');
			}
		}]
	}]);
});

